import { render, staticRenderFns } from "./tyoskentelyjaksot.vue?vue&type=template&id=f24dd0e0&scoped=true&"
import script from "./tyoskentelyjaksot.vue?vue&type=script&lang=ts&"
export * from "./tyoskentelyjaksot.vue?vue&type=script&lang=ts&"
import style0 from "./tyoskentelyjaksot.vue?vue&type=style&index=0&id=f24dd0e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24dd0e0",
  null
  
)

export default component.exports